import React from 'react';
import { gql } from '@apollo/client';
import { TextField, Show, SimpleShowLayout } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const MspShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField source="name" />
      <TextField source="label" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

MspShow.query = gql`
  query vms($id: Int!) {
    msp(id: $id) {
      id
      name
      label
      created_at
      updated_at
    }
  }
`;

export default MspShow;
